import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'percentageDiscount', standalone: true })
export class PercentageDiscountPipe implements PipeTransform {

  transform(mrp: number, sellingPrice: number): string {
    const percentDiscount = ((mrp - sellingPrice) / mrp) * 100;
    return percentDiscount >= 1 ? percentDiscount.toFixed() + '% off' : '';
  }

}
